module.exports = __webpack_public_path__ + "6c4a0dbc/img/dollar-icon.35c9d638.svg";